import styled, { css } from 'styled-components';

interface IContainerProps {
  isErrored: boolean;
  isFocused: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 0.4rem;
  width: 100%;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  height: 100%;

  label {
    display: flex;
    flex-direction: row;
    color: var(--black);
    font-size: 0.9rem;
  }

  .css-2b097c-container {
    background: transparent;
    flex: 1;
    display: flex;
    width: 100%;
    height: 100%;

    &,
    .react-select__control,
    .react-select__value-container,
    .css-1g6gooi {
      height: 2.4rem !important;
      font-size: 0.9rem;
      font-weight: 500;
      text-transform: uppercase;

      .react-select__input {
        padding-top: 0.2rem;

        input {
          height: 100%;
          text-transform: uppercase;
        }
      }
    }

    .react-select__control {
      flex: 1;
      cursor: pointer;
      background-color: var(--gray_light_light);
      border: 1px solid transparent;

      ${props =>
        props.isFocused &&
        css`
          border-color: var(--primary_color);
        `}

      ${props =>
        props.isErrored &&
        css`
          border-color: var(--red);
        `}
    }

    .react-select__control--is-focused {
      border-color: var(--primary_color);
      box-shadow: 0 0 0 transparent;
    }
    .react-select__indicator-separator {
      display: none;
    }

    .react-select__dropdown-indicator {
      color: var(--primary_color);
    }

    .react-select__menu {
      margin-left: 0;
      padding: 0.8rem;

      .react-select__option {
        text-align: center;
        cursor: pointer;
      }

      .react-select__option--is-focused {
        background: var(--primary_color);
        color: #fff;
      }
      .react-select__option--is-selected {
        background: var(--primary_color);
        color: #fff;
      }

      .react-select__option + .react-select__option {
        margin-left: 0;
      }
    }
  }

  .react-select--is-disabled {
    width: 100%;
    opacity: 0.5;

    .react-select__control {
      background-color: var(--gray_light_light);
      border: 0;

      font-size: 0.9rem;
      font-weight: 500;
      text-transform: uppercase;

      .css-g1d714-ValueContainer {
        height: 2.4rem;

        .css-107lb6w-singleValue {
          color: var(--gray);
        }
      }
    }
  }

  .input-error {
    top: 1.8rem;
    right: 1.8rem;
  }
`;
